import axios from "axios";
import { requestToken, requestTokenImage } from "./request_method";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/products`;


class InventoryServices {
  async getModelists() {
    try {
      let action = API_ROUTE + "/get-modelist";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async fetchModalParts(modelId) {
    try {
      let action = API_ROUTE + `/get-parts?model_id=${modelId}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async addPart(payload) {
    try {
      let action = API_ROUTE + "/add";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async updatePart(payload) {
    try {
      let action = API_ROUTE + "/edit";
      const response = await requestToken.put(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async deletePart(id) {
    try {
      let action = API_ROUTE + `/delete?id=${id}`;
      const response = await requestToken.del(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  // ------------------------------------------------------------------//

  async createStockLog(payload) {
    try {
      let action = API_ROUTE + "/";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
async getStockLogs(status) {
  try {
    let action = API_ROUTE + "/";

    const response = await requestToken.get(action,  { status },);
    return response;
  } catch (error) {
    console.log(error);
  }
}


  async getBillingLogs() {
    try {
      let action = API_ROUTE + "/billing";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async updateStockLog(payload) {
    try {
      let action = API_ROUTE + `/${payload.id}`;
      const response = await requestToken.put(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async updateStockLogNumber22(payload) {
    try {
      let action = API_ROUTE + `/${payload.id}/number22`;
      const response = await requestToken.put(action, { number22: payload.number22 ?? "" });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async deleteStockLog(id) {
    try {
      let action = API_ROUTE + `/${id}`;
      const response = await requestToken.del(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getModelStockData(model) {
    try {
      let action = API_ROUTE + `/model/${model}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getDeliveryLogs(payload) {
    try {
      let action = API_ROUTE + "/delivery";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async storeAdditionalLog(payload) {
    try {
      let action = API_ROUTE + "/additional";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getDeliveryStepsLogs(step) {
    try {
      let action = API_ROUTE + `/getStepLog?step=${step}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getDeliveryDataLogCounts() {
    try {
      let action = API_ROUTE + `/getCounts`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async registerNewDelivery(payload) {
    try {
      let action = API_ROUTE + "/register-delivery";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getDeliveryData(id) {
    try {
      let action = API_ROUTE + `/delivery/${id}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async storeCombinedDetail(payload) {
    try {
      let action = API_ROUTE + `/edit-finalize/${payload.deliveryId}`;
      const response = await requestToken.put(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async editDeliveryData(payload) {
    try {
      let action = API_ROUTE + "/editDeliveryData";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDelivery(deliveryId) {
    try {
      let action = API_ROUTE + `/delivery/${deliveryId}`;
      const response = await requestToken.del(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async downloadSampleDelivery() {
    try {
      let action = API_ROUTE + "/sample-delivery";
      const response = await axios.get(action, {
        headers: {
          token: `${window.localStorage.getItem("rbacToken")}`,
        },
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async downloadSampleBilling() {
    try {
      let action = API_ROUTE + "/sample-billing";
      const response = await axios.get(action, {
        headers: {
          token: `${window.localStorage.getItem("rbacToken")}`,
        },
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async downloadSampleStocks() {
    try {
      let action = API_ROUTE + "/sample-stocks";
      const response = await axios.get(action, {
        headers: {
          token: `${window.localStorage.getItem("rbacToken")}`,
        },
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async uploadDeliveryExcel(payload) {
    try {
      let action = API_ROUTE + "/upload-delivery";
      const response = await requestTokenImage.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
   async uploadDBillingExcel(payload) {
    try {
      let action = API_ROUTE + "/upload-billing";
      const response = await requestTokenImage.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

   async uploadStocksExcel(payload) {
    try {
      let action = API_ROUTE + "/upload-stocks";
      const response = await requestTokenImage.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default InventoryServices;
